module.exports = __webpack_public_path__ + "img/29565-048.2718f4f9.jpg";